"use client";

import Image from "next/image";
import Link from "next/link";
import { UserButton } from "@clerk/nextjs";

import { ThemeToggle } from "@/components/theme-toggle";

export function AppNavbar() {
  return (
    <header className="sticky top-0 z-30 border-b border-white/15 bg-black text-white">
      <div className="flex h-16 items-center justify-between gap-3 px-4 pl-16 sm:px-6 sm:pl-20 lg:pl-6">
        <Link href="/" className="flex items-center">
          <Image
            src="/budget-track.png"
            alt="Budget Track"
            width={120}
            height={40}
            priority
            className="h-12 w-auto"
          />
        </Link>

        <div className="flex items-center gap-2">
          <UserButton />
          <ThemeToggle className="border-white/50 bg-transparent text-white hover:bg-white/10 hover:text-white dark:border-white/50 dark:bg-transparent dark:hover:bg-white/10" />
        </div>
      </div>
    </header>
  );
}
